import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
const _excluded = ["children", "onClick", "shapeColor", "animated", "width", "height", "flat"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import css from '@styled-system/css';
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { layout, space } from 'styled-system';
const ShapeButtonWrapper = styled.button.withConfig({
  displayName: "ShapeButtonWrapper",
  componentId: "sc-1uk3c71-0"
})(["&&&{", " ", " background-color:transparent;border:none;filter:", ";}"], layout, space, props => props.hasShadow ? 'drop-shadow(0 14px 36px rgba(75, 80, 94, 0.1))' : 'none');
export const ShapeButton = React.forwardRef(function ShapeButton(props, ref) {
  const {
      children,
      onClick,
      shapeColor,
      animated,
      width,
      height,
      flat
    } = props,
    extraProps = _objectWithoutProperties(props, _excluded);
  const child = React.Children.only(children);
  const styledChildren = React.cloneElement(child, {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    fontSize: props.iconSize
  });
  return React.createElement(ShapeButtonWrapper, _extends({
    ref: ref,
    onClick: onClick,
    hasShadow: !flat
  }, extraProps), React.createElement(_StyledSvg, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 56",
    $_css: css({
      filter: flat ? 'none' : "drop-shadow(0 14px 36px rgba(75, 80, 94, 0.1))"
    })
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    id: "linear",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#cddffd"
  }), React.createElement("stop", {
    offset: "50%",
    stopColor: "#eabef4"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#f7dcc7"
  }))), React.createElement("path", {
    fill: shapeColor || 'url(#linear)',
    d: "M18.80141151616016 2.9999999999999996Q23.997563938866794 0 29.193716361573426 3L42.798975455026955 10.855Q47.99512787773359 13.855 47.99512787773359 19.855L47.99512787773359 35.565Q47.99512787773359 41.565 42.798975455026955 44.565L29.193716361573426 52.42Q23.997563938866794 55.42 18.80141151616016 52.42L5.196152422706632 44.565Q0 41.565 0 35.565L0 19.855Q0 13.855 5.196152422706632 10.855Z"
  }), animated && React.createElement(React.Fragment, null, React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "14",
    fill: "rgba(168, 200, 254, 0.5)"
  }), React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "20",
    fill: "rgba(168, 200, 254, 0.20)"
  }, React.createElement("animate", {
    attributeName: "r",
    from: "16",
    to: "22",
    dur: "2s",
    repeatCount: "indefinite"
  }), React.createElement("animate", {
    attributeName: "fill",
    from: "rgba(168, 200, 254, 0.20)",
    to: "rgba(204,169,44, 0)",
    dur: "2s",
    repeatCount: "indefinite"
  }))), React.createElement("foreignObject", {
    width: "48px",
    height: "56px",
    cursor: "pointer",
    x: "0",
    y: "0"
  }, styledChildren)));
});
ShapeButton.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  animated: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  flat: PropTypes.bool,
  shapeColor: PropTypes.string
}, propTypes.color), propTypes.border), propTypes.layout), propTypes.space), propTypes.typography), propTypes.textStyle) : {};
ShapeButton.defaultProps = {
  onClick: null,
  animated: false,
  width: '45px',
  height: '48px',
  iconSize: '18px',
  flat: false,
  shapeColor: '#FFFFFF'
};
var _StyledSvg = styled("svg").withConfig({
  displayName: "_StyledSvg",
  componentId: "sc-1uk3c71-1"
})(["", ""], p => p.$_css);